import React from "react";
import { useColors } from "../../constants/Colors";
import { useTranslation } from "react-i18next";

const FAQCard: React.FC = () => {
  const colors = useColors();
  const { t } = useTranslation();

  return (
    <div className="flex justify-center py-8">
      <div
        className="w-[80%] max-w-md rounded-3xl p-6"
        style={{ backgroundColor: colors.containerNeutralLightLowest }}
      >
        <p
          className="text-lg font-semibold"
          style={{ color: colors.textNeutralMuted }}
        >
          {t("faq_chat.title1") || "Welcome to"}
        </p>
        <img
          src="/240822-Flateroo-Logo-black-rgb.svg"
          alt="Flateroo"
          className="h-10 w-auto mt-1 mb-8"
          style={{
            filter:
              colors.textNeutralDefault === "#FFFFFF" ? "invert(1)" : "none",
          }}
        />
        <p style={{ color: colors.textNeutralDefault }}>
          {t("faq_chat.body")?.replace(/<\/?b>/g, "") ||
            "We are Niki and Lorin. If you have any questions, feedback, or need someone to blame, we're here for you."}
        </p>
        <p
          className="text-center text-xs mt-8"
          style={{ color: colors.textNeutralMuted }}
        >
          {t("by_students_for_students") || "By students, for students"}
        </p>
      </div>
    </div>
  );
};

export default FAQCard;
